import React, { useState, useEffect } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';

import { fetchData } from '../../../helpers/methods';

import SpinnerContainer from '../../../component-library/spinner-container';

import Ticket from './sub-components/ticket';

const ServiceNow = () => {
	const { uiMenuConfig } = useOutletContext();
	const { id } = useParams();
	const [loading, setLoading] = useState(true);
	const [ticketsData, setTicketsData] = useState([]);

	const getData = () => {
		fetchData({
			uri: `/api/web/svcmgmts/changerequests/${id}`,
			method: 'GET',
		})
			.then(({ ok, body }) => {
				if (ok) {
					const newTicketsData = body.result;
					setTicketsData(newTicketsData);
					setLoading(false);
				} else {
					setLoading(false);
				}
			})
			.catch(() => {
				setLoading(false);
			});
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<>
			<h3>{uiMenuConfig?.serviceNow?.label || 'ServiceNow'}</h3>
			{loading && (
				<SpinnerContainer padding={false} />
			)}
			{!loading && (
				<table className="table is-bordered">
					<thead>
						<tr>
							<th>Ticket Number</th>
							<th>Title</th>
							<th>Priority</th>
							<th>Type</th>
							<th>State</th>
							<th> </th>
						</tr>
					</thead>
					<tbody>
						{ticketsData?.length ? (
							ticketsData.map((item, index) => (
								<Ticket
									// eslint-disable-next-line react/no-array-index-key
									key={index}
									ticket={item}
								/>
							))
						) : (
							<tr>
								<td colSpan={6} className="grey-text text-center">No tickets available.</td>
							</tr>
						)}
					</tbody>
				</table>
			)}
		</>
	);
};

export default ServiceNow;
